<template>
  <div class="step-five tutorial">
    <h2>Sync your code with Github</h2>
    <p>As we are hosting the code in Azure Devops, sharing this with the wider world can be tricky. Firstly there is a privileges issue, as you must give access to users to see the entire project, rather than just the code. Secondly, and more importantly, if you get this wrong you might end up allowing people to change your code and even make changes to your live site! Sharing the code in a completely different repo gives us an extra buffer for security.</p>
    <h4>Setting up a github repo</h4>
    <h4>Getting your Access Token</h4>
    <h4>Adding to your pipeline</h4>
  </div>
</template>
